import apiClient from './client'
import type { MerchantRegistrationDto, InviteStaffDto } from '@/types/merchant'

export const merchantApi = {
  async staffLogin(credentials: { email: string; passwordHash: string }) {
    const response = await apiClient.post('/auth/login', {
      email: credentials.email,
      password: credentials.passwordHash,
    })
    return response.data.data
  },

  async register(data: MerchantRegistrationDto) {
    const response = await apiClient.post('/merchant/register', data)
    return response.data.data
  },

  async registerMerchant(data: MerchantRegistrationDto) {
    const response = await apiClient.post('/merchant/register', data)
    return response.data.data
  },

  async listPendingMerchants() {
    const response = await apiClient.get('/admin/merchants?status=PENDING')
    return response.data.data
  },

  async approveMerchant(merchantId: string) {
    const response = await apiClient.post(`/admin/merchants/${merchantId}/approve`)
    return response.data.data
  },

  async rejectMerchant(merchantId: string, reason?: string) {
    const response = await apiClient.post(`/admin/merchants/${merchantId}/reject`, { reason })
    return response.data.data
  },

  async getBrandDashboard(merchantId: string) {
    const response = await apiClient.get(`/merchant/${merchantId}/dashboard`)
    return response.data.data
  },

  async getBranchDashboard(branchId: string) {
    const response = await apiClient.get(`/merchant/branches/${branchId}/dashboard`)
    return response.data.data
  },

  async scanMember(memberQrCode: string) {
    const response = await apiClient.post('/staff/scan-member', { memberQrCode })
    return response.data.data
  },

  async confirmPurchase(payload: { memberQrCode: string; amount: number; note?: string }) {
    const response = await apiClient.post('/staff/confirm-purchase', payload)
    return response.data.data
  },

  async redeemReward(payload: { membershipId: string; rewardId: string }) {
    const response = await apiClient.post(`/membership/${payload.membershipId}/rewards/${payload.rewardId}/redeem`)
    return response.data.data
  },

  async getBranchQrToken(branchId: string) {
    const response = await apiClient.get(`/merchant/branches/${branchId}/qr-token`)
    return response.data.data
  },

  async listStaff(merchantId: string) {
    const response = await apiClient.get(`/merchant/${merchantId}/users`)
    return response.data.data
  },

  async inviteStaff(merchantId: string, data: InviteStaffDto) {
    const response = await apiClient.post(`/merchant/${merchantId}/users/invite`, data)
    return response.data.data
  },

  async updateStaff(merchantId: string, merchantUserId: string, data: any) {
    const response = await apiClient.put(`/merchant/${merchantId}/users/${merchantUserId}`, data)
    return response.data.data
  },

  async removeStaff(merchantId: string, merchantUserId: string) {
    const response = await apiClient.delete(`/merchant/${merchantId}/users/${merchantUserId}`)
    return response.data.data
  },
}
